import { render } from "./FooterComp.vue?vue&type=template&id=98857164"
import script from "./FooterComp.vue?vue&type=script&lang=js"
export * from "./FooterComp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\fire-conference\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__